import aes from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';
import { getParameterFromURL } from './getParameterFromUrl';

export function getEmailFromUrl(): string | null {
  const encrypted = getParameterFromURL('ev');
  if (!encrypted) return null;

  try {
    const decrypted = aes.decrypt(encrypted, '9213812384');
    const email = decrypted.toString(enc);
    return email || null;
  } catch {
    return null;
  }
}
